// extracted by mini-css-extract-plugin
export default {"empty":"ListEmpty_empty__SIe8Q"};